module.exports = __webpack_public_path__ + "static/media/gift05_zhCht.a7785bb1.png";